// extracted by mini-css-extract-plugin
export default {"banner":"UpdateBanner_banner__FrLdM","reload":"UpdateBanner_reload__DaF5s"};